import { z } from "zod";

export const informationSchema = z.object({
	title: z
		.string()
		.min(1, {
			message: "お知らせのタイトルを入力してください。",
		})
		.max(100, {
			message: "タイトルは100文字以内で入力してください。",
		}),
	body: z
		.string()
		.min(1, {
			message: "お知らせの本文を入力してください。",
		})
		.max(20000, {
			message: "本文は20000文字以内で入力してください。",
		}),
});

export type InformationFormValue = z.infer<typeof informationSchema>;
